import { useMemo } from 'react';
import { useProductOrders } from '../../../api/hooks/products/useProductOrders';
import { EntityPaginationData } from '../../../components/molecules/EntityPaginationData';
import { SORT_DIRECTION } from '../../../interfaces/enumerables';
import { ProductOrderItemCard } from './ProductOrderItemCard';

const PRODUCT_ORDERS_SORT_BY = { createdAt: { value: 'createdAt', label: 'SHARED.DATE' } };

const makeUseProductOrders = (productId: string) =>
  function useProductOrdersForProduct(
    page: number,
    _sortBy: any,
    _order: SORT_DIRECTION,
    _search: string,
    _type?: any,
  ) {
    return useProductOrders(productId, page);
  };

interface Props {
  productId: string;
}

export const ProductInvoices = ({ productId }: Props) => {
  const useProductOrdersForProduct = useMemo(() => makeUseProductOrders(productId), [productId]);

  return (
    <EntityPaginationData
      useDataHook={useProductOrdersForProduct}
      ItemCardData={ProductOrderItemCard}
      sortByFilter={PRODUCT_ORDERS_SORT_BY}
      hideCreateButton
      hideSearchButton
      hideFiltersSection
      sortByDefaultKey="createdAt"
      sortDirectionValue={SORT_DIRECTION.DESC}
      headerClass="entity-pagination-wrapper-embedded entity-pagination-wrapper-no-h-padding"
      noDataMsg="PRODUCTS.NO_ORDERS"
    />
  );
};
